import { jwtDecode } from 'jwt-decode';

import types, { IAction } from '../../types/actions';

export interface IAuthState {
	loading: boolean;
	user?: {
		accessToken: string;
		refreshToken: string;
		expAccessToken: number;
		expRefreshToken: number;
		userName?: string;
		roles: string[];
	};
	wrongCredentials: boolean;
}

const initialState: IAuthState = {
	user: undefined,
	loading: false,
	wrongCredentials: false,
};

export interface IJwt {
	email: number;
	exp: number;
	iat: number;
	id: number;
	name: string;
	roles: string;
}

export interface IUserToken extends Record<string, string> {
	accessToken: string;
	refreshToken: string;
}

export const authReducer = (state: IAuthState = initialState, action: IAction): IAuthState => {
	switch (action.type) {
		case types.LOGIN_SUCCESS:
		case types.REFRESH_TOKEN_SUCCESS: {
			const user: IUserToken = action.payload;
			const jwtAccessToken: IJwt = jwtDecode(user?.accessToken);
			if (jwtAccessToken) {
				const jwtRefreshToken: IJwt = jwtDecode(user?.refreshToken);
				return {
					...state,
					...{
						user: {
							accessToken: user.accessToken,
							expAccessToken: jwtAccessToken ? jwtAccessToken.exp : 0,
							expRefreshToken: jwtRefreshToken ? jwtRefreshToken.exp : 0,
							refreshToken: user.refreshToken,
							roles: [jwtAccessToken.roles],
							userName: jwtAccessToken.name,
						},
					},
					loading: false,
				};
			}
			return state;
		}
		case types.LOGIN_FAILURE:
			return {
				...state,
				...{
					user: undefined,
				},
				wrongCredentials: true,
			};
		case types.LOGOUT:
		case types.REFRESH_TOKEN_FAILURE:
			return {
				...initialState,
			};
		default:
			return state;
	}
};
